import { ChangeDetectorRef, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SharedServiceService } from 'app/core/shared-services/shared-service.service';
import { UpgradePackageComponent } from '../package-options/upgrade-package/upgrade-package.component';
import { DowngradePackageComponent } from '../package-options/downgrade-package/downgrade-package.component';
import { RelocateServiceComponent } from '../package-options/relocate-service/relocate-service.component';
import { EServiceAccountStatus, EServiceAccountStatusDetails, IResponse, StatusDetail } from 'app/core/shared-services/shared-interface.types';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { CommonModule, CurrencyPipe, NgFor, NgIf } from '@angular/common';
import { FuseCardComponent } from '@fuse/components/card';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CancelServiceComponent } from '../package-options/cancel-service/cancel-service.component';
import { RouterLink } from '@angular/router';
import { StrapiService } from 'app/core/shared-services/strapi.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { Subject, takeUntil } from 'rxjs';
import { RequestsComponent } from '../requests/requests.component';
import { ViewUsageComponent } from '../package-options/view-usage/view-usage.component';
import { AddOnComponent } from '../package-options/add-on/add-on.component';

 

@Component({
  selector: 'app-services',
  standalone: true,
  imports: [NgFor, FuseCardComponent, NgIf, CurrencyPipe, MatButtonModule, MatMenuModule, MatIconModule, CommonModule, MatProgressSpinnerModule, NgxSkeletonLoaderModule, RouterLink],
  templateUrl: './services.component.html',
  styleUrl: './services.component.scss',
})
export class ServicesComponent {
  @Output() servicesLength = new EventEmitter<number>();
  @Input() ordersLength: number;

  constructor(
    private breakpointObserver: BreakpointObserver,
  ) {}

  // ## VARS ##
  public serviceList: any = [];
  public addonList: any = [];
  public loading: boolean = false;
  public products: any = [];
  public isScreenSmall: boolean;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  // ## DEPENDENCIES ##
  private _sharedService = inject(SharedServiceService);
  private dialog = inject(MatDialog);
  private _sharedMethods = inject(SharedMethodsModule);
  private _changeDetectorRef = inject(ChangeDetectorRef);
  private _strapiService = inject(StrapiService);
  private _fuseMediaWatcherService = inject(FuseMediaWatcherService);

  // ## HOOKS ##
  async ngOnInit() {

    this._fuseMediaWatcherService.onMediaChange$
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(({matchingAliases}) =>
    {   
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes('md');
        
    });
    // clear list 
    await this.getProducts();
    await this._sharedMethods.getCustomerLeadsArray().then(async (res) => {
    await this.addLeadStatusToService(res);
    
    });
  }

  // ## METHODS ##
  public purchaseAddOn(service: any) {
    this.loading = true;
    this._sharedService.activeCustomerServices = service;
    this.dialog.open(AddOnComponent, {
      width: this.isScreenSmall ? '100vw' : '96vw',
      height: 'auto',
      backdropClass: 'blurModalBackground',
      disableClose: true
    }).afterClosed().subscribe(async() => {
      //await new Promise(resolve => setTimeout(resolve, 500)); //timing issue
      await this._sharedMethods.getCustomerLeadsArray().then(async (res) => {
        await this.addLeadStatusToService(res);
      this._changeDetectorRef.detectChanges();
    })});
  }

  public upgradePackage(service: any) {
    this.loading = true;
    this._sharedService.activeCustomerServices = service;
    this.dialog.open(UpgradePackageComponent, {
      width: this.isScreenSmall ? '100vw' : '96vw',
      height: this.isScreenSmall ? 'auto' : '80vh',
      backdropClass: 'blurModalBackground',
      disableClose: true
    }).afterClosed().subscribe(async() => {
      //await new Promise(resolve => setTimeout(resolve, 500)); //timing issue
      await this._sharedMethods.getCustomerLeadsArray().then(async (res) => {
        await this.addLeadStatusToService(res);
      this._changeDetectorRef.detectChanges();
    })});
  }

  public downgradePackage(service: any) {
    this.loading = true;
    this._sharedService.activeCustomerServices = service;
    this.dialog.open(DowngradePackageComponent, {
      width: this.isScreenSmall ? '100vw' : '96vw',
      height: this.isScreenSmall ? 'auto' : '80vh',
      backdropClass: 'blurModalBackground',
      disableClose: true
    }).afterClosed().subscribe(async() => {
     // await new Promise(resolve => setTimeout(resolve, 500)); //timing issue
      await this._sharedMethods.getCustomerLeadsArray().then(async (res) => {
        await this.addLeadStatusToService(res);
      this._changeDetectorRef.detectChanges();
    })});
  }

  public cancelPackage(service: any) {
    this.loading = true;
    this._sharedService.activeCustomerServices = service;
    this.dialog.open(CancelServiceComponent, {
      data: service,
      width: '800px',
      backdropClass: 'blurModalBackground'
    }).afterClosed().subscribe(async() => {
      await new Promise(resolve => setTimeout(resolve, 500)); //timing issue
      await this._sharedMethods.getCustomerLeadsArray().then(async (res) => {
        await this.addLeadStatusToService(res);
      this._changeDetectorRef.detectChanges();
    })});
  }

  public logIssue(service: any, type: string) {
    this.loading = true;
    this.dialog.open(RequestsComponent, {
      data: {service, from: 'Dashboard', type},
      width: '800px',
      backdropClass: 'blurModalBackground'
    });
  }

  public relocateService(service: any) {
    this.loading = true;
    this._sharedService.activeCustomerServices = service;
    this.dialog.open(RelocateServiceComponent, {
      width: '800px',
      backdropClass: 'blurModalBackground'
    });
  }

  public viewUsage(service: any) {
    this.loading = true;
    this._sharedService.activeCustomerServices = service;
    this.dialog.open(ViewUsageComponent, {
      data: {service},
      width: '800px',
      backdropClass: 'blurModalBackground'
    });
  }

  public getServiceStatus(status: EServiceAccountStatus): StatusDetail {
    const statusEnum = EServiceAccountStatus[status];
    return EServiceAccountStatusDetails[statusEnum];
  }

  public addSpace(text: string): string {
    if (!text) return '';
    return text.replace(/([a-z])([A-Z])/g, '$1 $2');
  }

  public undoCancellation(service: any) {
    this.loading = true;
    this._changeDetectorRef.detectChanges();
    this._sharedMethods.getCustomerLeads().then((res) => {
      res.result?.forEach(element => {
        if (element?.LeadActionTypeCode == "ServiceCancellation" || element?.LeadActionTypeCode == "ServiceDowngrade" || element?.LeadActionTypeCode == "ServiceUpgrade") {
          if (service?.EntityAccountOfferableEntityID === element?.UpdatingEntityAccountOfferableID) {
            this._sharedMethods.cancelLeadById(element.LeadEntityID).then((res) => {
              this.loading = false;
              this.ngOnInit();
            });
          }
        }
      });
    });
  }

  private async addLeadStatusToService(leads: any) {
    //  ## GET SERVICES AND ADD LATEST LEAD ACTION STATUS, TO SERVICE ##
    await this._sharedMethods.getCustomerActiveServices().then((res: IResponse) => {
      let response = [];
      res?.result?.records?.forEach(element => {
        for (let index = 0; index < leads.length; index++) {
          let leadsData = leads[index];
          if (element?.EntityAccountOfferableEntityID == leadsData?.UpdatingEntityAccountOfferableID) {
            element.LeadActionTypeCode = leadsData?.LeadActionTypeCode;
            element.upDownCancel = true;
            element.linkedLead = leadsData.LeadNumber
            break;
          }
        }
        response.push(element);
  
      });
      this.servicesLength.emit(response.length);
      this._changeDetectorRef.detectChanges();
      this.filterServices(response);
    });
  }

  private filterServices(service: any) {
    this.addonList = [];
    this.serviceList = [];
    service.forEach(element => {
      if(element.SubServiceTypeCode == 'Service:Internet:5G') {
        const foundProduct = this.products.filter(itm => itm.name == '5G');
        element.routerImage = foundProduct[0]?.fallbackImage[0]?.url;
      
        if(element.AddOnForAccountOfferableID) {
          this.addonList.push(element)
        } else {
          this.serviceList.push(element);
        }
      }
      if(element.SubServiceTypeCode == 'Service:Internet:FLTE') {
        const foundProduct = this.products.filter(itm => itm.name == 'Fixed-LTE');
        element.routerImage = foundProduct[0]?.fallbackImage[0]?.url;

        if(element.AddOnForAccountOfferableID) {
          this.addonList.push(element)
        } else {
          this.serviceList.push(element);
        }
      }
      if(element.SubServiceTypeCode == 'Service:Internet:FibreFTTH') {
        const foundProduct = this.products.filter(itm => itm.name == 'Fibre');
        element.routerImage = foundProduct[0]?.fallbackImage[0]?.url;
   
        if(element.AddOnForAccountOfferableID) {
          this.addonList.push(element)
        } else {
          this.serviceList.push(element);
        }
      }
      if(element.SubServiceTypeCode == 'Service:Internet:Microwave') {
        const foundProduct = this.products.filter(itm => itm.name == 'AirFibre');
        element.routerImage = foundProduct[0]?.fallbackImage[0]?.url;
        
        if(element.AddOnForAccountOfferableID) {
          this.addonList.push(element)
        } else {
          this.serviceList.push(element);
        }
      }
      if(element.SubServiceTypeCode == 'Service:Internet:MobileBroadband') {
        const foundProduct = this.products.filter(itm => itm.name == 'AirFibre');
        element.routerImage = foundProduct[0]?.fallbackImage[0]?.url;
        
        if(element.AddOnForAccountOfferableID) {
          this.addonList.push(element)
        } else {
          this.serviceList.push(element);
        }


      }
    });  
  }

  private async getProducts() {
   
    this._strapiService.GetProductsContent()
    .subscribe({
      next: async (res: any) => {
        this.products = res.data
        await this._sharedMethods.getCustomerLeadsArray().then(async (res) => {
          await this.addLeadStatusToService(res);
        });
      }
    })
  }

  private checkScreenSize(): void {
    this.breakpointObserver.observe(['(min-width: 768px)'])
    .subscribe((state: BreakpointState) => {
      // this.screenSize = state;
     
    })

  }




}
